import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();
const STORAGE_KEY = "sarvatra_auth";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setUser(parsed.user);
        setToken(parsed.token);
      } catch {
        localStorage.removeItem(STORAGE_KEY);
      }
    }
  }, []);

  const login = (data) => {
    console.log("LOGIN DATA:", data); // 🔍 DEBUG LINE

    if (!data?.token || !data?.user) {
      console.error("Invalid login payload", data);
      return;
    }

    setUser(data.user);
    setToken(data.token);

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        user: data.user,
        token: data.token
      })
    );
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem("user");
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}